const defaults = new Map()

defaults.set('flatfinderFramesSection', ctx => ({
  key: 'flatfinderFramesSection',
  label: ctx.$tc('image', 2),
  placement: 'flatfinder:builder',
  component: [
    {
      key: 'framesSection',
      component: 'Slot',
    },
  ],
  options: {
    collapsible: false,
    size: 2,
    layout: 'framesSection framesSection',
    props: {
      _parent: {
        sublabel: ctx.$t('uploadMoreImagesToCreate360View'),
      },
    },
  },
}))

export default defaults
